import { GqlPermissions } from "~/__generated__";
import useHasTenantPermission from "~/modules/auth/hooks/useHasPermission";

import ProjectVisitListAdminScreen from "./ProjectVisitListAdminScreen";
import ProjectVisitListClientScreen from "./ProjectVisitListClientScreen";

export function ProjectVisitListScreen() {
    const isAdmin = useHasTenantPermission(GqlPermissions.Administrator);

    return isAdmin ? <ProjectVisitListAdminScreen /> : <ProjectVisitListClientScreen />;
}
